import { Stack, Text } from '@mantine/core';
import type { ReactNode } from 'react';

interface MetaPairProps {
  label: string;
  /** An em dash reads as "not set"; an empty string reads as a broken render. */
  value: ReactNode;
}

/**
 * A labelled fact, for the header of a detail page.
 *
 * These were `StatTile`s on the journey screen, which was a misuse: "iOS" is not
 * a statistic, and giving it the same weight as a measured figure made a header
 * read as five equally important numbers. Kept here rather than in one route so
 * the two detail pages agree on what a fact looks like.
 */
export function MetaPair({ label, value }: MetaPairProps) {
  return (
    <Stack gap={2}>
      <Text size="xs" fw={600} c="dimmed">
        {label.toUpperCase()}
      </Text>
      <Text size="sm" fw={600} component="div">
        {value}
      </Text>
    </Stack>
  );
}
